module.exports = __webpack_public_path__ + "static/media/blog-2.857f1e97.jpg";